//Colors as per style guide 2.0
const colorsArray = [
    { "background-color" : "#E5EDFB", "color" : "#0044AA", "border": "1px solid #99BBEE" }, //Blue
    { "background-color" : "#E6E7EC", "color" : "#0C1435", "border": "1px solid #9FA3B3" }, //Dark
    { "background-color" : "#E5F7E9", "color" : "#008C24", "border": "1px solid #99DFAB" }, //Green
    { "background-color" : "#FCE8E9", "color" : "#B51920", "border": "1px solid #F4A5A9" }, //Red
    { "background-color" : "#FEF2E8", "color" : "#C4681A", "border": "1px solid #FBCDA5" }, //Orange
    { "background-color" : "#E8F5F5", "color" : "#1C817B", "border": "1px solid #A7D9D6" }, //Jade
    { "background-color" : "#F4ECFE", "color" : "#763AC1", "border": "1px solid #D4B6F9" }, //Violet
    { "background-color" : "#FCEBF7", "color" : "#AF2E8F", "border": "1px solid #F1B0E1" }, //Fuchsia
    { "background-color" : "#FFFBE7", "color" : "#CBAB12", "border": "1px solid #FFEFA2" }, //Yellow
]

export const userColorDetails = {
    colorsArray
}